// Mock data for サロンハブ prototype

export const mockCustomers = [
  {
    id: '1',
    name: '山田花子',
    phone: '090-1234-5678',
    email: 'yamada@example.com',
    lastVisit: '2025-01-08',
    visitCount: 15,
    totalSpent: 245000,
    staff: '田中',
    status: 'active',
    age: 34,
    preferences: 'カラーは赤みを抑えた色味を希望。土曜日の午前中が都合良い。',
    nextVisitProbability: 85,
    recommendedService: 'ドライヘッドスパ60分',
    lifetimeValue: 180000,
  },
  {
    id: '2',
    name: '鈴木美咲',
    phone: '080-9876-5432',
    email: 'suzuki@example.com',
    lastVisit: '2025-01-10',
    visitCount: 8,
    totalSpent: 124000,
    staff: '佐藤',
    status: 'active',
    age: 28,
    preferences: 'リラックス重視、静かな環境を好む',
    nextVisitProbability: 65,
    recommendedService: 'アロマヘッドスパ45分',
    lifetimeValue: 95000,
  },
  {
    id: '3',
    name: '高橋真理',
    phone: '070-5555-6666',
    email: 'takahashi@example.com',
    lastVisit: '2025-01-12',
    visitCount: 23,
    totalSpent: 387000,
    staff: '田中',
    status: 'vip',
    age: 41,
    preferences: '長時間コース希望、定期メンテナンス',
    nextVisitProbability: 95,
    recommendedService: 'プレミアムヘッドスパ90分',
    lifetimeValue: 285000,
  },
  {
    id: '4',
    name: '伊藤優子',
    phone: '090-3333-4444',
    email: 'ito@example.com',
    lastVisit: '2025-01-14',
    visitCount: 5,
    totalSpent: 67000,
    staff: '山本',
    status: 'new',
    age: 25,
    preferences: '初回お試し、短時間コース希望',
    nextVisitProbability: 45,
    recommendedService: 'ベーシックヘッドスパ30分',
    lifetimeValue: 52000,
  },
];

export const mockReservations = [
  {
    id: '1',
    customerId: '1',
    customerName: '山田花子',
    service: 'ドライヘッドスパ60分',
    staff: '田中',
    date: '2025-01-20',
    time: '10:00',
    duration: 60,
    price: 8500,
    status: 'confirmed',
    notes: '肩こりがひどいとのこと',
  },
  {
    id: '2',
    customerId: '3',
    customerName: '高橋真理',
    service: 'プレミアムヘッドスパ90分',
    staff: '田中',
    date: '2025-01-20',
    time: '14:00',
    duration: 90,
    price: 12000,
    status: 'confirmed',
    notes: '定期メンテナンス',
  },
  {
    id: '3',
    customerId: '2',
    customerName: '鈴木美咲',
    service: 'アロマヘッドスパ45分',
    staff: '佐藤',
    date: '2025-01-21',
    time: '15:30',
    duration: 45,
    price: 6500,
    status: 'pending',
    notes: 'アロマオイルの希望あり',
  },
];

export const mockSalesData = [
  { month: '2024-07', sales: 2200000, customers: 280, avgSpending: 7857 },
  { month: '2024-08', sales: 2350000, customers: 295, avgSpending: 7966 },
  { month: '2024-09', sales: 2180000, customers: 275, avgSpending: 7927 },
  { month: '2024-10', sales: 2420000, customers: 310, avgSpending: 7806 },
  { month: '2024-11', sales: 2650000, customers: 325, avgSpending: 8154 },
  { month: '2024-12', sales: 2800000, customers: 320, avgSpending: 8750 },
  { month: '2025-01', sales: 2950000, customers: 340, avgSpending: 8676 },
];

export const mockPredictions = {
  salesForecast: {
    nextMonth: 3200000,
    confidence: 87,
    weeklyBreakdown: [780000, 820000, 800000, 800000],
    factors: ['季節需要増加', '新規キャンペーン効果', '常連客の定期来店'],
    risks: ['競合店舗の新規出店', '経済状況の変化'],
    opportunities: ['平日14-16時の活用', 'アップセル施策'],
  },
  customerBehavior: [
    {
      customerId: '1',
      name: '山田花子',
      probability: 85,
      timeframe: '2週間以内',
      recommendedAction: '来週火曜日に予約案内',
      confidence: 92,
    },
    {
      customerId: '2',
      name: '鈴木美咲',
      probability: 65,
      timeframe: '3週間以内',
      recommendedAction: '特別割引オファー',
      confidence: 78,
    },
    {
      customerId: '3',
      name: '高橋真理',
      probability: 95,
      timeframe: '1週間以内',
      recommendedAction: '定期メンテナンス提案',
      confidence: 96,
    },
  ],
};

export const mockClaudeResponses = {
  salesIncrease: {
    analysis: '店舗データを分析した結果、以下3つの戦略をお勧めします',
    recommendations: [
      {
        title: '平日14-16時の空き時間活用',
        description: '「平日限定リラックスコース」で新規開拓',
        expectedIncrease: 180000,
        priority: 'high',
      },
      {
        title: '既存顧客のアップセル強化',
        description: 'ヘッドスパ+αメニューで客単価20%UP',
        expectedIncrease: 250000,
        priority: 'high',
      },
      {
        title: 'リピート率改善施策',
        description: '施術後のアフターケア提案で継続率85%→95%向上',
        expectedIncrease: 150000,
        priority: 'medium',
      },
    ],
    confidence: 92,
  },
  
  competitorAnalysis: {
    position: 'above_average',
    strengths: ['高い顧客満足度', '優秀なスタッフ', '立地の良さ'],
    improvements: [
      '客単価を¥9,000台にUPで月+¥150,000',
      '稼働率88%達成で月+¥200,000見込み',
      'リピート率92%で年間+¥500,000',
    ],
    benchmarks: {
      sales: { yours: 2800000, average: 2100000, top10: 3500000 },
      avgSpending: { yours: 8500, average: 7200, top10: 9800 },
      repeatRate: { yours: 85, average: 78, top10: 92 },
      utilization: { yours: 75, average: 68, top10: 88 },
    },
  },
};

export const mockStaff = [
  {
    id: '1',
    name: '田中美香',
    role: 'オーナー・マネージャー',
    experience: '10年',
    specialties: ['ヘッドスパ', '経営戦略'],
    schedule: 'フルタイム',
    performance: {
      customerSatisfaction: 4.9,
      monthlyRevenue: 850000,
      repeatCustomers: 23,
    },
  },
  {
    id: '2',
    name: '佐藤恵子',
    role: 'シニアセラピスト',
    experience: '7年',
    specialties: ['アロマテラピー', 'リラクゼーション'],
    schedule: 'フルタイム',
    performance: {
      customerSatisfaction: 4.8,
      monthlyRevenue: 720000,
      repeatCustomers: 18,
    },
  },
  {
    id: '3',
    name: '山本さくら',
    role: 'セラピスト',
    experience: '3年',
    specialties: ['ベーシックケア', '新規対応'],
    schedule: 'パートタイム',
    performance: {
      customerSatisfaction: 4.6,
      monthlyRevenue: 420000,
      repeatCustomers: 12,
    },
  },
];

export const planPricing = {
  light: {
    name: 'ライトプラン',
    price: 19800,
    features: [
      '基本的な予約管理',
      '顧客管理（1,000名まで）',
      '売上データ確認',
      '基本レポート',
      'メールサポート',
    ],
    limitations: [
      'AI分析機能なし',
      '外部API連携なし',
      'スタッフ数制限（5名まで）',
    ],
  },
  standard: {
    name: 'スタンダードプラン',
    price: 39800,
    features: [
      'すべてのライト機能',
      'AI分析・予測機能',
      '顧客管理（5,000名まで）',
      '外部API連携',
      '詳細レポート',
      'チャットサポート',
    ],
    limitations: [
      'ホワイトラベル機能なし',
      'カスタムブランディングなし',
    ],
  },
  premium: {
    name: 'プレミアムプラン',
    price: 79800,
    features: [
      'すべてのスタンダード機能',
      '無制限顧客管理',
      'ホワイトラベル機能',
      'カスタムブランディング',
      '専任サポート',
      'API完全アクセス',
    ],
    limitations: [],
  },
};